const SENSITIVE_QUERY_PARAMS = [
  'token',
  't',
  'jwt',
  'code',
  'reset_token',
  'access_token',
  'id_token',
  'refresh_token',
  'state',
  'signature',
  'sig',
] as const;

type SanitizableEvent =
  | {
      properties?: Record<string, unknown>;
    }
  | null
  | undefined;

export function redactSensitiveQueryParams(url: string): string {
  try {
    const parsed = new URL(url, window.location.origin);
    let redacted = false;

    for (const param of SENSITIVE_QUERY_PARAMS) {
      if (parsed.searchParams.has(param)) {
        parsed.searchParams.set(param, '[redacted]');
        redacted = true;
      }
    }

    return redacted ? parsed.toString() : url;
  } catch {
    return url;
  }
}

export function sanitizePostHogEvent<T extends SanitizableEvent>(event: T): T {
  if (!event?.properties) {
    return event;
  }

  const properties = { ...event.properties };
  let changed = false;

  for (const key of ['$current_url', '$referrer'] as const) {
    const value = properties[key];
    if (typeof value === 'string') {
      const redacted = redactSensitiveQueryParams(value);
      if (redacted !== value) {
        properties[key] = redacted;
        changed = true;
      }
    }
  }

  return changed ? { ...event, properties } : event;
}
